import { SET_EMAIL, SET_URL } from '../mutation_types'

const state = {
  get_email: '',
  get_url: ''
}

const mutations = {
  [SET_EMAIL] (state, data) {
    state.get_email = data
  },
  [SET_URL] (state, data) {
    state.get_url = data
  }
}

const actions = {
  SET_EMAIL ({commit}, data) {
    commit(SET_URL, data)
  },
  SET_URL ({commit}, data) {
    commit(SET_URL, data)
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/activity.js